export default "__VITE_ASSET__DKdO4fXs__"